<template>
  <div id="datecomponent">
    <div class="datebox">
      <select
        @change="changeDateOptionDropdown"
        class="form-control"
        v-model="selectedDateOption"
      >
        <option :value="i" v-for="(d, i) in dateOptions">{{ d.label }}</option>
      </select>
    </div>
    <div class="datebox" v-if="selectedDateOption != 'alldate'">
      <datepicker
        placeholder="From"
        @input="changeCustomDate"
        v-model="date.startDate"
        :disabled="date.disableInStartDate"
        :disabled-picker="isPickerLock"
      />
    </div>
    <div class="datebox" v-if="selectedDateOption != 'alldate'">
      <datepicker
        placeholder="To"
        @input="changeCustomDate"
        v-model="date.endDate"
        :disabled="date.disableInEndDate"
        :disabled-picker="isPickerLock"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";

export default {
  name: "datecomponent",
  components: { Datepicker },
  props: ["noSaveProp"],
  data: function () {
    return {
      channelSelector: "",
      selectedDateOption: "",
      dateOptions: {},
      isPickerLock: false,
      date: {
        startDate: "",
        endDate: "",
        disableInStartDate: {
          from: "",
          to: "",
        },
        disableInEndDate: {
          from: "",
          to: "",
        },
      },
    };
  },
  mounted() {
    this.createDateOptions();

    if (this.$route.name != "Sentiment" && this.$route.name != "Dashboard") {
      this.checkLocalStorage();
    } else {
      this.selectedDateOption = "custom";
      let startDate = this.dateOptions[this.selectedDateOption].startDate;
      let endDate = this.dateOptions[this.selectedDateOption].endDate;
      this.setDates(startDate, endDate);
    }
  },
  methods: {
    createDateOptions() {
      this.dateOptions = {
        alldate: { label: "All Dates", startDate: "", endDate: "" },
        today: { label: "TODAY", startDate: moment(), endDate: moment() },
        yesterday: {
          label: "YESTERDAY",
          startDate: moment().subtract(1, "days"),
          endDate: moment().subtract(1, "days"),
        },
        last7days: {
          label: "LAST 7 DAYS",
          startDate: moment().subtract(7, "days"),
          endDate: moment(),
        },
        thisweek: {
          label: "THIS WEEK",
          startDate: moment().startOf("isoWeek"),
          endDate: moment(),
        },
        lastweek: {
          label: "LAST WEEK",
          startDate: moment().subtract(1, "weeks").startOf("isoWeek"),
          endDate: moment().subtract(1, "weeks").endOf("isoWeek"),
        },
        lastbusinessweek: {
          label: "LAST BUSINESS WEEK",
          startDate: moment().subtract(1, "weeks").startOf("isoWeek"),
          endDate: moment().subtract(1, "weeks").endOf("isoWeek").subtract(2, "days"),
        },
        thismonth: {
          label: "THIS MONTH",
          startDate: moment().startOf("month"),
          endDate: moment(),
        },
        lastmonth: {
          label: "LAST MONTH",
          startDate: moment().subtract(1, "month").startOf("month"),
          endDate: moment().subtract(1, "month").endOf("month"),
        },
        last14days: {
          label: "LAST 14 DAYS",
          startDate: moment().subtract(14, "days"),
          endDate: moment(),
        },
        last30days: {
          label: "LAST 30 DAYS",
          startDate: moment().subtract(30, "days"),
          endDate: moment(),
        },
        thisweeksuntoday: {
          label: "THIS WEEK SUN TODAY",
          startDate: moment().startOf("isoWeek").subtract(1, "days"),
          endDate: moment(),
        },
        thisweekmontoday: {
          label: "THIS WEEK MON TODAY",
          startDate: moment().startOf("isoWeek"),
          endDate: moment(),
        },
        lastweeksuntothissat: {
          label: "LAST WEEK SUN TO THIS SAT",
          startDate: moment().subtract(1, "weeks").startOf("isoWeek").subtract(1, "days"),
          endDate: moment().subtract(1, "weeks").startOf("isoWeek").add(5, "days"),
        },
        custom: {
          label: "Custom Date",
          startDate: moment().subtract(30, "days"),
          endDate: moment(),
        },
      };
      if (this.$route.name != "Sentiment") {
        delete this.dateOptions.alldate;
      }
      if (this.$route.name == "Sentiment" || this.$route.name == "Dashboard") {
        this.dateOptions.custom.startDate = moment().subtract(1, "year").startOf("year");
      }
    },

    checkLocalStorage() {
      if (this.$route.name == "Sentiment" && localStorage.hasOwnProperty("vocDatesAll")) {
        let storageDates = JSON.parse(localStorage.getItem("vocDatesAll"));
        this.selectedDateOption = storageDates.selectedDateOption;
        this.setDates(storageDates.startDate, storageDates.endDate);
      } else {
        localStorage.removeItem("vocDatesAll");
        if (localStorage.hasOwnProperty("vocDates")) {
          let storageDates = JSON.parse(localStorage.getItem("vocDates"));
          this.selectedDateOption = storageDates.selectedDateOption;
          this.setDates(storageDates.startDate, storageDates.endDate);
        } else {
          this.selectedDateOption = "custom";
          let startDate = moment().subtract(1, "year").format("YYYY-MM-DD");
          let endDate = this.dateOptions[this.selectedDateOption].endDate;
          this.setDates(startDate, endDate);
        }
      }
    },

    changeCustomDate() {
      this.setDates(this.date.startDate, this.date.endDate);
      this.saveDatesInStorage();
    },

    changeDateOptionDropdown() {
      let startDate = this.dateOptions[this.selectedDateOption].startDate;
      let endDate = this.dateOptions[this.selectedDateOption].endDate;
      this.setDates(startDate, endDate);
      this.saveDatesInStorage();
    },

    setDates(startDate, endDate) {
      if (startDate) this.date.startDate = moment(startDate).format("YYYY-MM-DD");
      else this.date.startDate = startDate;
      if (endDate) this.date.endDate = moment(endDate).format("YYYY-MM-DD");
      else this.date.endDate = endDate;
      this.refreshPickerLocking();
      this.setDisabledDates();
    },

    refreshPickerLocking() {
      if (this.selectedDateOption == "custom") this.isPickerLock = false;
      else this.isPickerLock = true;
    },

    setDisabledDates() {
      this.date.disableInStartDate.from = moment(this.date.endDate).toDate();
      this.date.disableInEndDate.from = moment().toDate();
      this.date.disableInEndDate.to = moment(this.date.startDate).toDate();
    },

    saveDatesInStorage() {
      if (this.$route.name == "Sentiment" || this.$route.name == "Dashboard") {
        return;
      }
      if (!this.noSaveProp) {
        let obj = {
          selectedDateOption: this.selectedDateOption,
          startDate: this.date.startDate,
          endDate: this.date.endDate,
        };
        if (this.$route.name == "Sentiment" && this.selectedDateOption == "alldate") {
          localStorage.setItem("vocDatesAll", JSON.stringify(obj));
        } else {
          localStorage.setItem("vocDates", JSON.stringify(obj));
          localStorage.removeItem("vocDatesAll");
        }
      }
    },
  },
};
</script>
<style scoped>
#datecomponent {
  display: inline;
}
.datebox {
  width: 11% !important;
}
</style>
